import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'app-a-date-range-setting',
  templateUrl: './a-date-range-setting.component.html',
  styleUrls: ['./a-date-range-setting.component.scss'],
})
export class ADateRangeSettingComponent implements OnInit {
  @Input() dateScopeStart!: Date;
  @Input() dateScopeEnd!: Date;
  @Input() initialStartDate!: Date;
  @Input() initialEndDate!: Date;
  //such of Start of Month, Start of Year etc...
  @Input() initialStartType!: string;
  //such of End of Month, End of Year etc...
  @Input() initialEndType!: string;
  @Input() position: 'right' | 'left' = 'right';
  @Input() format: string = 'yyyy/MM/dd';
  @Output() onCancel: EventEmitter<any> = new EventEmitter();
  @Output() onApply: EventEmitter<{
    start: Date;
    end: Date;
    customData: any;
    startType: string;
    endType: string;
  }> = new EventEmitter();
  @Output() onReset: EventEmitter<{
    start: Date;
    end: Date;
    customData: any;
    startType: string;
    endType: string;
  }> = new EventEmitter();
  @Input() toolbarTemplate?: TemplateRef<any>;
  toolbarTplContext: any = {
    setCustomData: (data: any) => {
      if (!this.customData) {
        this.customData = data;
        this.initCustomData = data;
      } else {
        this.customData = { ...this.customData, ...data };
      }
    },
    component: null,
  };
  startDate!: Date;
  endDate!: Date;
  //such of Start of Month, Start of Year etc...
  startType: string;
  //such of End of Month, End of Year etc...
  endType: string;
  customData: any;
  initCustomData: any;

  constructor() {}

  ngOnInit(): void {
    this.toolbarTplContext.component = this;
    this.startDate = this.initialStartDate;
    this.endDate = this.initialEndDate;
    this.startType = this.initialStartType;
    this.endType = this.initialEndType;
    //this.initCustomData = this.customData;
  }

  resetDefaultValue() {
    this.startDate = this.initialStartDate;
    this.endDate = this.initialEndDate;
    this.startType = this.initialStartType;
    this.endType = this.initialEndType;
    this.customData = this.initCustomData;
    this.onReset.emit({
      start: this.startDate,
      end: this.endDate,
      startType: this.startType,
      endType: this.endType,
      customData: this.customData,
    });
  }

  cancle() {
    this.onCancel.emit();
  }

  apply() {
    this.onApply.emit({
      start: this.startDate,
      end: this.endDate,
      startType: this.startType,
      endType: this.endType,
      customData: this.customData,
    });
  }

  onDateRangeChange(event: any) {
    this.startDate = event.start;
    this.endDate = event.end;
    this.startType = event.startType;
    this.endType = event.endType;
  }
}
